import React from 'react'
import { Outlet } from 'react-router'
import { useLocation } from 'react-router-dom';
import TitleComponent from '../../components/admin/title';
import {ReactComponent as HomeIcon} from '../../images/icons/Dashboard.svg'
import {ReactComponent as ProductIcon} from '../../images/icons/Listing.svg'
import {ReactComponent as StoreIcon} from '../../images/admin/sidebar/store.svg'
import {ReactComponent as FilesIcon} from '../../images/admin/sidebar/files.svg'
import {ReactComponent as AlgorithmIcon} from '../../images/icons/Hashtag.svg'
import {ReactComponent as UserIcon} from '../../images/icons/User_Active.svg'
import {ReactComponent as OrderIcon} from '../../images/icons/Orders.svg'

const Title = () => {
    const currentRoute = useLocation().pathname.toLowerCase();
  return (
    <div>
      {currentRoute.includes('dashboard') &&
        <TitleComponent Name='Dashboard' Icon={HomeIcon}/>
      }
      {currentRoute.includes('onlinestore') &&
        <TitleComponent Name='Online Store' Icon={StoreIcon}/>
      }
      {currentRoute.includes('products') &&
        <TitleComponent Name='Products' Icon={ProductIcon}/>
      }
      {currentRoute.includes('files') &&
        <TitleComponent Name='Files' Icon={FilesIcon}/>
      }
      {currentRoute.includes('algorithm') &&
        <TitleComponent Name='Algorithm' Icon={AlgorithmIcon}/>
      }
      {currentRoute.includes('user') &&
        <TitleComponent Name='User' Icon={UserIcon}/>
      }
      {currentRoute.includes('orders') &&
        <TitleComponent Name='Orders' Icon={OrderIcon}/>
      }
      <div className='admin_body_container'>
        <Outlet/>
      </div>
    </div>
  )
}

export default Title
